import { Button, Input } from '@mui/joy';

import { FormEvent, useMemo, useState } from 'react';

import { Dialog, DialogContent } from '@/components/Dialog/Dialog';
import { Tooltip } from '@/design-system';
import { PlaygroundSettingsSchema } from '@/types/schema';

export const ConfigurationCrudModal = ({
  isOpen,
  setIsOpen,
  isLoading,
  title,
  currentConfigId,
  allSettings,
  handleSubmit,
}: {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  title: string;
  currentConfigId: string | null;
  allSettings: PlaygroundSettingsSchema[];
  handleSubmit: (e: FormEvent, name: string, description: string) => void;
  isLoading: boolean;
}) => {
  const [name, setName] = useState(
    allSettings.find((config) => config.id === currentConfigId)?.name ?? ''
  );
  const [description, setDescription] = useState(
    allSettings.find((config) => config.id === currentConfigId)?.description ??
      ''
  );

  const submitDisabledMessage = useMemo(() => {
    if (!name) return 'Name cannot be empty';
    return allSettings
      .filter((config) => config.id !== currentConfigId)
      .find((config) => config.name === name)
      ? 'Configuration with this name already exists'
      : undefined;
  }, [name, allSettings, currentConfigId]);

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent title={title}>
        <form
          onSubmit={(e) => handleSubmit(e, name, description)}
          className="mt-2 flex flex-col gap-3"
        >
          <div className="flex flex-col gap-1">
            <div className="text-sm font-medium">Configuration Name</div>
            <Input value={name} onChange={(e) => setName(e.target.value)} />
          </div>
          <div className="flex flex-col gap-1">
            <div className="text-sm font-medium">Description (optional)</div>
            <Input
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </div>
          <Tooltip title={submitDisabledMessage}>
            <div>
              <Button
                type="submit"
                loading={isLoading}
                disabled={!!submitDisabledMessage}
              >
                Save
              </Button>
            </div>
          </Tooltip>
        </form>
      </DialogContent>
    </Dialog>
  );
};
